import PropTypes from 'prop-types';
import { useState, useLayoutEffect } from 'react';
// material
import { useMediaQuery } from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default function DashboardLayout({ children }) {
  const [open, setOpen] = useState(true);
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  useLayoutEffect(() => {
    if (lgDown) setOpen(false);
  }, [lgDown]);

  return (
    <RootStyle>
      <DashboardNavbar isOpenSidebar={open} onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle open={open} className="main-style">
        {children}
      </MainStyle>
    </RootStyle>
  );
}
